import React from "react";
import { useSelector } from "react-redux";
import { Breadcrumbs as BreadcrumbsMUI, Grid2 as Grid } from "@mui/material";
import { Link } from "react-router-dom";
import LoaderComponent from "../LoaderComponent/LoaderComponent";
import ButtonComponent from "../ButtonComponent/ButtonComponent";

function ContentViewComponent(
    props = {
        loading: false,
        breadcrumbs: {},
        action: {},
    },
) {
    const screenReducer = useSelector((state) => state.ScreenReducer);
    const [isSmallView, setSmallView] = React.useState(false);

    React.useEffect(() => {
        setSmallView(screenReducer.screen === "XS" || screenReducer.screen === "SM");
    }, [screenReducer.screen]);

    return (
        <div style={{ paddingRight: 20, paddingLeft: 20, marginTop: isSmallView ? 85 : 20 }}>
            {props.loading ? (
                <LoaderComponent />
            ) : (
                <>
                    {props.breadcrumbs && (
                        <Grid
                            container
                            justifyContent={"space-between"}
                            alignItems={"center"}
                            sx={{ pb: '10px' }}>
                            <Grid size={{ xs: 12, sm: 12, md: props.action ? "auto" : 12 }}>
                                <h4
                                    style={{
                                        color: 'var(--greytext)',
                                        fontSize: isSmallView
                                            ? '15px'
                                            : '18px',
                                        fontWeight: 600,
                                        margin: 0,
                                        borderBottom: 'var(--greytext) double 2px'
                                    }}>
                                    {props.breadcrumbs.title}
                                </h4>
                                <BreadcrumbsMUI separator={'›'} aria-label="breadcrumb" sx={{
                                    color: 'var(--greytext)',
                                    width: '100%',
                                    padding: '0px 40px',
                                    height: 60,
                                    boxSizing: 'border-box',
                                    '& p': {
                                        marginTop: '17px',
                                        fontSize: 13,
                                        fontWeight: 300,
                                        color: 'var(--greytext)'
                                    },
                                    '& a': {
                                        margin: 0,
                                        marginTop: 3,
                                        fontSize: 13,
                                        fontWeight: 300,
                                        color: '#000',
                                        '&:hover': {
                                            color: 'var(--thememarron)'
                                        }
                                    },
                                    '& .MuiBreadcrumbs-root': {
                                        color: 'var(--greytext)',
                                        marginLeft: -30,
                                        marginBottom: 8
                                    }
                                }}>
                                    {props.breadcrumbs.links &&
                                        props.breadcrumbs.links.map((link, key) => {
                                            return (
                                                <Link to={link.path} key={key} className={"link"}>
                                                    {link.label}
                                                </Link>
                                            );
                                        })}
                                    <p>{props.breadcrumbs.context}</p>
                                </BreadcrumbsMUI>
                            </Grid>
                            {props.action && (
                                <Grid size={{ xs: 12, sm:12,  md: "auto" }}>
                                    <ButtonComponent label={props.action.label} onClick={props.action.onClick} disabled={props.action.disabled ? props.action.disabled : false} />
                                </Grid>
                            )}
                        </Grid>
                    )}
                    {props.children}
                </>
            )}
        </div>
    );
}

export default ContentViewComponent;
